import {
  FAVORITE_SLIDES_GROUP,
  FAVORITE_SLIDES_GROUP_UI,
} from 'utilities/constants';

export const formatSlideGroupName = (name) =>
  name === FAVORITE_SLIDES_GROUP ? FAVORITE_SLIDES_GROUP_UI : name;
